import React from 'react'
import ProductsShirts from './ProductsShirts'

export default function Shirts() {
  return (
    <div>Shirts
        <ProductsShirts/>
    </div>
  )
}
